import React from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Redirect } from "react-router";
import propTypes from "prop-types";
import { getUserDetail, registerAccessToken } from "./actions";
import ErrorMessage from "../../components/ErrorMessage";
import "../../styles/login.scss";
import { createFetch } from "../../utils";
const { API_SERVER_URL, ORIGIN, URL_PREFIX, SF_URL } = window;

class Login extends React.Component {
  constructor() {
    super();
    this.state = {
      announcement: "",
      loading: false,
      form: {
        username: "",
        password: "",
      },
      validation: [],
      showPassword: false,
    };
    this.login = this.login.bind(this);
    this.triggerForgetPassword = this.triggerForgetPassword.bind(this);
    this.updateFormValue = this.updateFormValue.bind(this);
    this.togglePassword = this.togglePassword.bind(this);
  }

  async componentWillMount() {
    const { body } = await fetch(
      "https://jsonplaceholder.typicode.com/posts/1"
    ).then((res) => res.json());
    this.setState({ announcement: body });
  }

  async login(e) {
    e.preventDefault();
    if (this.state.loading) {
      return;
    }
    this.setState({ loading: true });
    try {
      const { username, password } = this.state.form;
      const result = await fetch(`${API_SERVER_URL}auth/login`, {
        headers: {
          "Content-Type": "application/json",
          Origin: ORIGIN,
        },
        method: "POST",
        mode: "cors",
        body: JSON.stringify({ username, password }),
      }).then((res) => res.json());
      if (result.status === 400) {
        this.setState({ validation: result.validation || [] });
        if (result.validation === undefined) throw new Error(result.message);
      } else if (result.status === 200) {
        this.props.registerAccessToken(result.token, result.expired);
        this.props.getUserDetail(result.token);
      }
      this.setState({ loading: false });
    } catch (error) {
      Swal.fire({
        allowEnterKey: true,
        type: "warning",
        backdrop: true,
        title: "An error occured",
        text: error.toString(),
      });
      this.setState({ loading: false });
    }
  }

  updateFormValue(e) {
    const { form } = this.state;
    form[e.target.name] = e.target.value;
    this.setState({ form });
  }

  async triggerForgetPassword(e) {
    e.preventDefault();
    const { value: email } = await Swal.fire({
      allowEnterKey: true,
      text: "Please enter your email address.",
      title: "Forget password",
      type: "info",
      input: "email",
      showCancelButton: true,
      inputValidator: (val) => {
        // eslint-disable-next-line no-control-regex
        if (
          /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/gi.test(
            val
          ) === false
        ) {
          return "Your email is invalid";
        }
        return null;
      },
    });
    this.setState({ loading: true });
    if (email) {
      const result = await createFetch({
        path: "auth/forget-password",
        body: {
          emailOrUsername: email,
        },
        method: "POST",
      });
      if (result.status === 200) {
        Swal.fire({
          title: "Password reset sent to your email",
          text: result.message,
          type: "success",
        });
      } else {
        Swal.fire({
          title: "Failed to reset password.",
          text: result.message,
          type: "error",
        });
      }
    }
    this.setState({ loading: false });
  }

  togglePassword() {
    const { showPassword } = this.state;
    this.setState({ showPassword: !showPassword });
  }

  render() {
    const { announcement, validation, loading, showPassword } = this.state;
    const { username, password } = this.state.form;
    if (this.props.user.accessToken !== null) {
      return <Redirect to={`${URL_PREFIX}/app`} />;
    }
    return (
      <div className="col-lg-12" id="loginPage">
        <div className="col-lg-12 header row">
          <div className="col-lg-2 col-md-3 col-sm-4">
            <img
              src={require("../../static/img/logo-gems-login.png")}
              alt="logo-gems"
            />
          </div>
          <div className="col-lg-2 col-md-3 col-sm-4">
            <a href={SF_URL} target="_blank" rel="noopener noreferrer">
              LOGIN TO SALESFORCE
            </a>
          </div>
          <div className="col-sm-2 col-md-3 col-sm-4">
            <a
              href="https://wakatobiresort.vendhq.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              LOGIN TO VEND
            </a>
          </div>
        </div>
        <div id="mid-section" className="col-lg-10 col-lg-offset-1">
          <div className="col-sm-6 col-md-8 col-lg-8 announcement">
            <h1>Guests Experience Management System</h1>
            <p>Making every experience unique</p>
          </div>
          <div className="col-sm-6 col-md-4 col-lg-4 login-box">
            <img
              src={require("../../static/img/logo-wakatobi.png")}
              alt="logo-wakatobi"
            />
            <h2>Sign In</h2>
            <p className="text-center">
              {loading ? (
                <i className="fa fa-circle-notch fa-spin fa-4x loading" />
              ) : null}
            </p>
            <form className="" method="POST" onSubmit={this.login}>
              <div className="col-sm-12">
                <input
                  name="username"
                  className="form-control"
                  placeholder="Username"
                  type="text"
                  value={username}
                  onChange={this.updateFormValue}
                />
                <ErrorMessage validation={validation} fieldName="username" />
              </div>
              <div className="col-sm-12">
                <div className="input-group">
                  <input
                    name="password"
                    className="form-control"
                    placeholder="Password"
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={this.updateFormValue}
                    style={{ borderRight: 0 }}
                  />
                  <div
                    className="input-group-addon"
                    onClick={() => this.togglePassword()}
                    style={{ cursor: "pointer" }}
                    style={{
                      borderColor: "#ccc",
                      borderWidth: "1px 1px 1px 0",
                      backgroundColor: "#fff",
                    }}
                  >
                    <i
                      className={`fa ${
                        showPassword ? "fa-eye-slash" : "fa-eye"
                      }`}
                      aria-hidden="true"
                    />
                  </div>
                </div>
                <ErrorMessage validation={validation} fieldName="password" />
                <button
                  type="submit"
                  className="btn btn-primary btn-block"
                  disabled={loading}
                >
                  {loading ? "Signing in..." : "Sign In"}
                </button>
              </div>
            </form>
            <div className="col-sm-12" style={{ marginTop: 5 }}>
              <p style={{ textAlign: "right" }}>
                <Link
                  onClick={this.triggerForgetPassword}
                  to={`${URL_PREFIX}/forget-password`}
                >
                  Forget Password?
                </Link>
              </p>
            </div>
          </div>
        </div>
        <div className="col-lg-10 col-lg-offset-1 footer">
          <p style={{ fontSize: 20, color: "#fff" }}>
            Powered by&nbsp;&nbsp;
            <img
              src={require("../../static/img/logo-interaktiv.png")}
              alt="interaktiv.sg"
            />
          </p>
        </div>
      </div>
    );
  }
}

Login.propTypes = {
  getUserDetail: propTypes.func.isRequired,
  registerAccessToken: propTypes.func.isRequired,
  user: propTypes.object.isRequired,
};
Login.defaultProps = {};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getUserDetail,
      registerAccessToken,
    },
    dispatch
  );

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
